<form #form="ngForm">
  <spk-card [class]="'col-md-3'" meta="{{ getActionText() }} Example" title="{{model.DisplayText}}" [divider]="true">
    <spk-text name="DisplayText" maxlength="100" [(model)]="model.DisplayText"></spk-text>
    <spk-textarea name="Value" maxlength="500" rows="12" [(model)]="model.Value"></spk-textarea>
    <spk-select name="ExampleLookupId" [(model)]="model.ExampleLookupId" [options]="exampleLookupOptions" optionTextProperty="label" optionValueProperty="value"></spk-select>
  </spk-card>
</form>